import CampoFecha from '../CampoFecha'
import { colors, font, text, radius } from '../../design/tokens'

/**
 * El período de un reporte (Martin, 15 oct 2026): atajos (Hoy, Ayer, 7, 14,
 * 30 días, Desde–hasta) y flechas ‹ › que corren el período en bloques de su
 * mismo largo (7 días → la semana anterior; Hoy → ayer, anteayer…). La regla
 * vive en el backend (PeriodoReporte): acá solo se piden `periodo`, `offset`,
 * `desde`, `hasta` y se muestra la `etiqueta` que vuelve.
 *
 * `onCambiar(patch)` recibe solo lo que cambia.
 */
export default function BarraPeriodo({ p, onCambiar, grande = false }) {
  const tam = grande ? { btn: 44, fs: 15 } : { btn: 30, fs: text.body }
  const flecha = (dir, habilitada, onClick, label) => (
    <button type="button" aria-label={label} disabled={!habilitada} onClick={onClick}
      style={{ width: tam.btn, height: tam.btn, flexShrink: 0, borderRadius: radius.sm, border: `1px solid ${colors.border}`, background: colors.bg,
        color: habilitada ? colors.text : colors.textPlh, cursor: habilitada ? 'pointer' : 'default', fontSize: tam.fs + 4, lineHeight: 1, fontFamily: font.sans }}>
      {dir}
    </button>
  )
  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {flecha('‹', true, () => onCambiar({ offset: (p.offset || 0) + 1 }), 'Período anterior')}
        <div style={{ flex: 1, minWidth: 0, textAlign: 'center', fontWeight: 600, fontSize: tam.fs, color: colors.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {p.etiqueta}
        </div>
        {flecha('›', (p.offset || 0) > 0, () => onCambiar({ offset: Math.max(0, (p.offset || 0) - 1) }), 'Período siguiente')}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: grande ? 'center' : 'flex-start' }}>
        {p.opciones.map(o => {
          const activo = p.valor === o.valor
          return (
            <button key={o.valor} type="button"
              onClick={() => onCambiar(o.valor === 'rango' ? { periodo: 'rango', offset: 0, desde: p.desde, hasta: p.hasta } : { periodo: o.valor, offset: 0, desde: undefined, hasta: undefined })}
              style={{ border: `1px solid ${activo ? colors.link : colors.border}`, background: activo ? colors.linkBg : colors.bg, color: activo ? colors.link : colors.text,
                borderRadius: radius.pill, padding: grande ? '7px 12px' : '3px 10px', fontSize: grande ? 14 : text.sec, fontWeight: activo ? 600 : 400, cursor: 'pointer', fontFamily: font.sans }}>
              {o.label}
            </button>
          )
        })}
        {(p.offset || 0) > 0 && (
          <button type="button" onClick={() => onCambiar({ offset: 0 })}
            style={{ border: 'none', background: 'none', color: colors.link, fontSize: grande ? 14 : text.sec, fontWeight: 600, cursor: 'pointer', fontFamily: font.sans }}>
            Volver a hoy
          </button>
        )}
      </div>
      {p.valor === 'rango' && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <CampoFecha value={p.desde} onChange={v => onCambiar({ desde: v, offset: 0 })} style={{ width: 120 }} aria-label="Desde" />
          <span style={{ color: colors.textSec, fontSize: text.sec }}>al</span>
          <CampoFecha value={p.hasta} onChange={v => onCambiar({ hasta: v, offset: 0 })} style={{ width: 120 }} aria-label="Hasta" />
        </div>
      )}
    </div>
  )
}

/** Chips de selección múltiple (lista, origen) o de una opción (canal). */
export function Chips({ p, onCambiar, grande = false }) {
  const multi = p.tipo === 'multi'
  const elegidos = multi ? (p.valor || []) : [p.valor ?? '']
  const tocar = (v) => {
    if (!multi) return onCambiar({ [p.clave]: v || undefined })
    const nuevo = elegidos.includes(v) ? elegidos.filter(x => x !== v) : [...elegidos, v]
    onCambiar({ [p.clave]: nuevo })
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
      <span style={{ fontSize: grande ? 13 : text.sec, color: colors.textSec, minWidth: grande ? 52 : undefined }}>{p.label}</span>
      {multi && elegidos.length === 0 && <span style={{ fontSize: grande ? 13 : text.meta, color: colors.textMeta }}>todas</span>}
      {p.opciones.map(o => {
        const activo = elegidos.includes(o.valor)
        return (
          <button key={o.valor || 'todos'} type="button" onClick={() => tocar(o.valor)} aria-pressed={activo}
            style={{ border: `1px solid ${activo ? colors.link : colors.border}`, background: activo ? colors.linkBg : colors.bg, color: activo ? colors.link : colors.text,
              borderRadius: radius.pill, padding: grande ? '6px 11px' : '2px 9px', fontSize: grande ? 14 : text.sec, fontWeight: activo ? 600 : 400, cursor: 'pointer', fontFamily: font.sans }}>
            {o.label}
          </button>
        )
      })}
    </div>
  )
}
